import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {OptionsListModule} from '../options-list/options-list.module';
import { DropdownPortalDirective } from './dropdown-portal.directive';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { DropdownWithOverlayOptionsListComponent } from './dropdown-with-overlay-options-list.component';

@NgModule({
  declarations: [
    DropdownWithOverlayOptionsListComponent,
    DropdownPortalDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OptionsListModule,
    OverlayModule,
    PortalModule
  ],
  exports: [
    DropdownWithOverlayOptionsListComponent,
  ],
})
export class DropdownWithOverlayOptionsListModule {
}
